export default __webpack_public_path__ + "static/media/radio-checked.8107dc8d.svg";